__turbopack_context__.v({
  "className": "fontmono_8aea6c6d-module__VQqN2q__className",
  "variable": "fontmono_8aea6c6d-module__VQqN2q__variable",
});
